import { useMemo, useState } from 'react'
import type { SupplierRow, SupplierTab } from './SupplierList.types'

export function useTabState(approvedRows: SupplierRow[], initialPendingRows: SupplierRow[]) {
  const [activeTab, setActiveTab] = useState<SupplierTab>('approved')
  const [pendingRows, setPendingRows] = useState<SupplierRow[]>(initialPendingRows)

  const activeRows = useMemo(() => {
    return activeTab === 'approved' ? approvedRows : pendingRows
  }, [activeTab, approvedRows, pendingRows])

  return {
    activeTab,
    setActiveTab,
    pendingRows,
    setPendingRows,
    activeRows,
  }
}
